/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Error_InvalidInputs */



/**
* | output |
* | --- |
* | "Some rows contain invalid data. Please check the file." |
*
* @param {Alarms_Import_Error_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_import_error_invalid = /** @type {((inputs?: Alarms_Import_Error_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Error_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Some rows contain invalid data. Please check the file.")
	return /** @type {LocalizedString} */ ("Certaines lignes contiennent des données invalides. Veuillez vérifier le fichier.")
});